export abstract class DynamicComponent {
    context: any;
}
